import React from 'react';
export default function Location() {
  return (
  <section id="location" className="content-section light find-us-section">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-5 find-us-title">Find Us</h2>
            <p className="lead text-center mb-5 find-us-subtitle">Located in the heart of Panhala, Maharashtra, our hotel offers easy access to the historic Panhala Fort and breathtaking mountain views.</p>
            
            {/* Coordinates */}
            <div className="coordinates-container mb-5">
                <div className="row">
                    <div className="col-md-3 col-6 mb-3">
                        <div className="coordinate-item">
                            <div className="coordinate-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="coordinate-label">Latitude</div>
                            <div className="coordinate-value">16.8167° N</div>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="coordinate-item">
                            <div className="coordinate-icon">
                                <i className="fas fa-globe"></i>
                            </div>
                            <div className="coordinate-label">Longitude</div>
                            <div className="coordinate-value">74.1167° E</div>
                    </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="coordinate-item">
                            <div className="coordinate-icon">
                                <i className="fas fa-mountain"></i>
                            </div>
                            <div className="coordinate-label">Altitude</div>
                            <div className="coordinate-value">2,953 ft</div>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                        <div className="coordinate-item">
                            <div className="coordinate-icon">
                                <i className="fas fa-road"></i>
                            </div>
                            <div className="coordinate-label">Distance from Fort</div>
                            <div className="coordinate-value">0.5 km</div>
                        </div>
                    </div>
                </div>
            </div>
 
            {/* Map */}
            <div className="row mb-4">
                <div className="col-lg-10 mx-auto">
                    <div className="map-container">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3829.1234567890123!2d74.1167!3d16.8167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTbCsDQ5JzAwLjAiTiA3NMKwMDcnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890123" 
                                style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" width="100%" height="450"></iframe>
                    </div>
                </div>
            </div>

            {/* Location Highlights */}
            <div className="row">
                <div className="col-lg-8 mx-auto">
                    <div className="location-highlight">
                        <h6><i className="fas fa-star text-warning me-2"></i>Prime Location Benefits</h6>
                        <p>Our strategic location offers the perfect balance of accessibility and tranquility. Just 0.5 km from the historic Panhala Fort, you can enjoy both the convenience of nearby attractions and the peaceful serenity of our mountain retreat. The hotel's elevation of 2,953 ft provides cool mountain air and spectacular panoramic views throughout the year.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}